<div class="payment-icons">
  <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="credit-card-payment-icon">
  <img src="assets/payment-type/arca.svg" alt="">
</div>
